import React from "react";
import UserWiseTableData from "./UserWiseTableData";
import { ALL_USER_WISE_HEADER } from "../../../../constant/tableHeadersConstants/UserAndClientWiseOCRReportConst";
import { InvoiceUserData } from "../../../../redux/listing/listingTypes";
import SignleUserWiseTableData from "./SingleUserWiseTableData";

type AppProps = {
  userWiseOCRReportList: InvoiceUserData[] | [];
  data: InvoiceUserData[] | [];
  setData: React.Dispatch<React.SetStateAction<[] | InvoiceUserData[]>>;
  finalUser: string;
};

const UserWiseTable = ({
  userWiseOCRReportList,
  data,
  setData,
  finalUser,
}: AppProps) => {
  return (
    <div>
      <div className="jobsType" >
        <table className="table thead-light table-bordered"  style={{overflowX: "auto"}}>
          <thead className="text-start">
            <tr>
              {/* {(finalUser === "Select..."||finalUser === "All") ? <th></th> : ""} */}
              <th>{(finalUser === "Select..."||finalUser === "All") ? "USER" : "DATE"}</th>
              <th>EXPENSES</th>
              <th>SALES</th>
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {(finalUser === "All"||finalUser === "Select...") ? (
              <UserWiseTableData
                data={data}
                setData={setData}
                tableHeader={ALL_USER_WISE_HEADER}
              />
            ) : (
              <SignleUserWiseTableData
                data={data}
                setData={setData}
                tableHeader={ALL_USER_WISE_HEADER}
              />
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserWiseTable;
